import { render, staticRenderFns } from "./ButtonLogout.vue?vue&type=template&id=26b0735f&scoped=true&lang=pug"
import script from "./ButtonLogout.vue?vue&type=script&lang=ts"
export * from "./ButtonLogout.vue?vue&type=script&lang=ts"
import style0 from "./ButtonLogout.vue?vue&type=style&index=0&id=26b0735f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b0735f",
  null
  
)

export default component.exports